module.exports = __webpack_public_path__ + "static/media/microscope2.00ec960a.jpg";